// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ArrowsAltOutlinedSvg from "@ant-design/icons-svg/es/asn/ArrowsAltOutlined";
import AntdIcon from '../components/AntdIcon';

var ArrowsAltOutlined = function ArrowsAltOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ArrowsAltOutlinedSvg
  }));
};

ArrowsAltOutlined.displayName = 'ArrowsAltOutlined';
export default React.forwardRef(ArrowsAltOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ArrowsAltOutlined.js
// module id = 601
// module chunks = 0